import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';

const RadioField = ({ field, form, onChange, ...restProps }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-row gap-3">
      {restProps?.options?.map((option) => {
        return (
          <div key={option.id} className="d-flex align-items-center">
            <RadioButton
              inputId={option.id}
              name={field.name}
              value={option.value}
              disabled={option.disabled}
              onChange={(e) => {
                onChange?.(e);
                form.setFieldValue(field.name, e.value);
              }}
              checked={get(form.values, field.name) === option.value}
            />
            <label htmlFor={option.id} className="mx-2">
              {t(option.label)}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(RadioField);
